import { CmsObjectWithDefault } from '@components/Cms/types';

export type MagicLinkFormCmsKey = 'CheckYourEmail' | 'EmailSent' | 'ResendEmail';

export const MagicLinkFormCmsWithDefaultV2: CmsObjectWithDefault<MagicLinkFormCmsKey> = {
    CheckYourEmail: {
        cmsId: 311090,
        defaultTranslation: 'Check your email',
    },
    EmailSent: {
        cmsId: 311091,
        defaultTranslation:
            "An email has been sent to {0} with a verification link. Please click the button in the email to confirm your identity. If you can't find the email in your inbox, please check your spam folder.",
    },
    ResendEmail: {
        cmsId: 206407,
        defaultTranslation: 'Resend email',
    },
};
